<template>
  <div class="index">
    <!-- 公告弹窗 -->
    <el-dialog
      :title="goAnnounceMsg.title"
      :visible.sync="centerDialogVisibleMsg"
      width="60%"
      center
    >
      <!-- item.content, item.title, -->
      <p style="text-align: center">
        发布人：<span style="color: #1b5bbf; margin-right: 20px">
          {{ goAnnounceMsg.publishBy }}</span
        >
        发布时间：
        {{ goAnnounceMsg.publishTime }}
      </p>
      <p
        style="
          min-height: 200px;
          margin: 10px 0;
          padding: 10px 0;
          max-height: 300px;
          overflow-y: auto;
        "
        v-html="goAnnounceMsg.content"
      ></p>
    </el-dialog>
    <div class="sm-content">

      <div class="wrapConter">
        <img :src="bg" alt />
      </div>
      <div class="msgGallaryTop" style="z-index: 59">
        <div class="topLeft">
          <img
            :src="require('@/assets/suppliers/home_icon_lb.png')"
            alt
            class="laba"
          />
          <div>
            <!-- <p>系统公告：</p> -->
            <Marquee :marqueeList="marqueeList"></Marquee>
          </div>
          <div class="topRight">
            <!-- <div>查看更多</div>
                    <img :src="home_icon_ck" alt class="more" /> -->
          </div>
        </div>
      </div>
      
      <div class="wrapBottom">
        <div class="left l-flex-column">
          <div class="leftTop">
            <div class="item" @click="toMyDilian">
              <img :src="wddl" alt />
              <p style="color:#87B2F2">我的迪链</p>
            </div>
            <div class="item" @click="toQianfa">
              <img :src="wyqianfa" alt />
              <p>我要签发</p>
            </div>
            <div class="item" @click="toZiyuan">
              <img :src="wyqf" alt />
              <p>我的资源</p>
            </div>
            
            <div class="item" @click="toQingfen">
              <img :src="wdzy" alt />
              <p>我要清分</p>
            </div>

            <div class="item" @click="toDiscount" style="margin-right: 0">
              <img :src="xjzk" alt />
              <p>现金折扣</p>
            </div>

          </div>
          <el-row
            class="leftBottom"
            type="flex"
            :gutter="20"
            justify="space-between"
          >
            <el-col :span="8">
              <el-card class="boxCard" shadow="hover">
                <div class="cardHeader">
                  <div class="topLeft">
                    <img :src="daiban" alt />
                    <span class="titleStyle">签发</span>
                  </div>
                  <div
                    class="topRight"
                    style="cursor: pointer"
                    @click="moreSign"
                  >
                    <div class="tips printer">更多</div>
                    <img :src="jiantou" alt class="pointer"/>
                  </div>
                </div>
                <div class="clearfix">
                  <span class="dot"></span>
                  <span class="littleTitle">待签发</span>
                </div>
                <div class="amount">
                  <span>{{waitSignAmount || "0.00" }}</span>
                  <img
                    :src="jiantou"
                    alt
                    style="cursor: pointer"
                    @click="moreSign"
                  />
                </div>
                <div class="clearfix">
                  <span class="dot"></span>
                  <span class="littleTitle">已签发</span>
                </div>
                <div class="amount">
                  <span>{{hasSignedAmount || "0.00" }}</span>
                  <img
                    :src="jiantou"
                    alt
                    style="cursor: pointer"
                    @click="skipToMyDiLink"
                  />
                </div>
                <div class="clearfix">
                  <span class="dot"></span>
                  <span class="littleTitle">当月已签发</span>
                </div>
                <div class="amount">
                  <span>{{hasSignedMonthAmount || "0.00" }}</span>
                  <img
                    :src="jiantou"
                    alt
                    @click="skipToMyDiLink"
                    style="cursor: pointer"
                  />
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="boxCard" shadow="hover">
                <div class="cardHeader">
                  <div class="topLeft">
                    <img :src="daiban" alt />
                    <span class="titleStyle">清分</span>
                  </div>
                  <div
                    class="topRight"
                    style="cursor: pointer"
                    @click="moreSort"
                  >
                    <div class="tips pointer">更多</div>
                    <img :src="jiantou" alt class="pointer"/>
                  </div>
                </div>
                <div class="clearfix">
                  <span class="dot"></span>
                  <span class="littleTitle">待清分</span>
                </div>
                <div class="amount">
                  <span>{{ cardData.toSettleSum | moneyFLoatFormat }}</span>
                  <img
                    :src="jiantou"
                    alt
                    style="cursor: pointer"
                    @click="moreSort"
                  />
                </div>
                <div class="clearfix">
                  <span class="dot"></span>
                  <span class="littleTitle">已清分</span>
                </div>
                <div class="amount">
                  <span>{{ cardData.settledsum | moneyFLoatFormat }}</span>
                  <img
                    :src="jiantou"
                    alt
                    style="cursor: pointer"
                    @click="skipToMyDiLink"
                  />
                </div>
                <div class="clearfix">
                  <span class="dot"></span>
                  <span class="littleTitle">当月已清分</span>
                </div>
                <div class="amount">
                  <span>{{ cardData.settledmonthsum | moneyFLoatFormat }}</span>
                  <img
                    :src="jiantou"
                    alt
                    style="cursor: pointer"
                    @click="skipToMyDiLink"
                  />
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="boxCard" shadow="hover">
                <div class="cash-discount" style="height: 357px">
                  <div class="cardHeader">
                    <div class="topLeft">
                      <img :src="daiban" alt />
                      <span class="titleStyle">现金折扣</span>
                    </div>
                    <div
                      class="topRight"
                      style="cursor: pointer"
                      @click="moreCash"
                    >
                      <div class="tips pointer">更多</div>
                      <img :src="jiantou" alt class="pointer"/>
                    </div>
                  </div>
                  <div class="clearfix">
                    <span class="dot"></span>
                    <span class="littleTitle">待放款</span>
                  </div>
                  <div class="amount">
                    <span>{{ cardData.toPaySum | moneyFLoatFormat }}</span>
                    <img
                      :src="jiantou"
                      alt
                      style="cursor: pointer"
                      @click="moreCash"
                    />
                  </div>
                  <div class="clearfix">
                    <span class="dot"></span>
                    <span class="littleTitle">已放款</span>
                  </div>
                  <div class="amount">
                    <span>{{ cardData.paidSum | moneyFLoatFormat }}</span>
                    <img
                      :src="jiantou"
                      alt
                      style="cursor: pointer"
                      @click="alreadyCash"
                    />
                  </div>
                  <!-- <div class="clearfix">
                                        <span class="dot"></span>
                                        <span class="littleTitle">待签发</span>
                                    </div> -->
                  <!-- <div class="amount">
                                        200000元
                                    </div> -->
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div class="right">
          <el-card class="boxCard dbcard" shadow="hover">
            <div class="cardHeader" @click="goview(1)">
              <div class="topLeft">
                <img :src="daiban" alt class="pointer"/>
                <span class="titleStyle">我的待办</span>
              </div>
              <div
                class="topRight"
                v-if="runTodoList && runTodoList.length > 0"
              >
                <div class="tips pointer">更多</div>
                <img :src="jiantou" alt class="pointer"/>
              </div>
            </div>
            <template v-if="runTodoList.length > 0">
              <div
                class="infoBox clearfix"
                :key="index"
                v-for="(item, index) in runTodoList"
              >
                <div class="dotBox">
                  <span class="dot"></span>
                </div>
                <!-- <p class="info printer" @click="tobeListDetail(item)">{{ item.wf_def_name }}</p> -->
                <ellipsis-tooltip
                  @click.native="tobeListDetail(item)"
                  :tooltipText="item.wf_def_name"
                />
                <div class="moreBox" @click="tobeListDetail(item)">
                  <img :src="home_icon_ck" alt />
                </div>
              </div>
            </template>
            <template v-else>
              <div style="color: #999; text-align: center">暂无数据</div>
            </template>
          </el-card>
          <el-card class="boxCard ggcard" shadow="hover">
            <div class="cardHeader" @click="goview(2)">
              <div class="topLeft">
                <img :src="gg" alt class="pointer"/>
                <span class="titleStyle">公告消息</span>
              </div>
              <div
                class="topRight"
                v-if="AnnounceList && AnnounceList.length > 0"
              >
                <div class="tips pointer">更多</div>
                <img :src="jiantou" alt class="pointer"/>
              </div>
            </div>
            <template v-if="AnnounceList.length > 0">
              <div
                class="infoBox clearfix"
                :key="index"
                v-for="(item, index) in AnnounceList"
              >
                <div class="dotBox" @click="goAnnounceDteail(item)">
                  <span class="dot"></span>
                </div>
                <!-- <p class="info" @click="goAnnounceDteail(item)">
                  {{ item.title }}
                </p> -->
                <ellipsis-tooltip
                  @click.native="goAnnounceDteail(item)"
                  :tooltipText="item.title"
                />
                <div class="moreBox" @click="goAnnounceDteail(item)">
                  <img :src="home_icon_ck" alt />
                </div>
              </div>
            </template>
            <template v-else>
              <div style="color: #999; text-align: center">暂无数据</div>
            </template>
          </el-card>
          <el-card class="boxCard wdcard" shadow="hover">
            <div class="cardHeader" @click="goview(3)">
              <div class="topLeft">
                <img :src="wdzx" alt class="pointer"/>
                <span class="titleStyle">文档中心</span>
              </div>
              <div
                class="topRight"
                v-if="documentCenterList && documentCenterList.length"
              >
                <div class="tips pointer">更多</div>
                <img :src="jiantou" alt class="pointer"/>
              </div>
            </div>
            <template v-if="documentCenterList.length > 0">
              <div
                class="infoBox clearfix"
                :key="index"
                v-for="(item, index) in documentCenterList"
                @click="upDocumentCenter(item)"
              >
                <div class="dotBox">
                  <span class="dot"></span>
                </div>
                <!-- <p class="info fileName">{{ item.fileName }}</p> -->
                <ellipsis-tooltip :tooltipText="item.fileName" />
                <div class="moreBox">
                  <img :src="home_icon_ck" alt />
                </div>
              </div>
            </template>
            <template v-else>
              <div style="color: #999; text-align: center">暂无数据</div>
            </template>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wddl from "@/assets/submember/dilian.png";
import wdzy from "@/assets/submember/qingfen.png";
import wyqf from "@/assets/submember/ziyuan.png";
import wyqianfa from "@/assets/submember/qianfa.png";
import xjzk from "@/assets/submember/zhekou.png";


import xxbg from "@/assets/submember/xxbg.png";
import bg from "@/assets/suppliers/bg_image.png";
import daiban from "@/assets/submember/daiban.png";
import gg from "@/assets/submember/gg.png";
import wdzx from "@/assets/submember/wdzx.png";
import home_icon_ck from "@/assets/suppliers/home_icon_ck.png";
import home_icon_lb from "@/assets/suppliers/home_icon_lb.png";
import jiantou from "@/assets/suppliers/jiantou.png";
import Marquee from "@/components/public/announceTemplate.vue";
import { getAnnounceList } from "@/views/operationCenter/home";
import EllipsisTooltip from "@/components/public/EllipsisTooltip.vue";
import bus from "@/components/public/bus.js";
export default {
  name: "SubMember",
  components: {
    Marquee,
    EllipsisTooltip,
  },
  data() {
    return {
      pageData: {},
      hasSignedAmount:"",
      waitSignAmount:"",
      hasSignedMonthAmount:"",
      wddl,
      wdzy,
      wyqianfa,
      wyqf,
      xjzk,

      xxbg,
      bg,
      home_icon_lb,
      home_icon_ck,
      daiban,
      gg,
      wdzx,
      jiantou,
      AnnounceList: [],
      marqueeList: [],
      documentCenterList: [],
      cardData: {},
      runTodoList: [],
      // 公告弹窗
      centerDialogVisibleMsg: false,
      goAnnounceMsg: {},
      firstDate: "",
      lastDate: "",
    };
  },
  created() {
    this.getSignData();
    this.getSignData2();
    this.getSignData3();
    // this.getSortedData()
    this.getCardData();
    this.getAnnounceList();
    // 文档列表
    this.getShowList();
    //我的待办列表
    this.runToBeList();
  },
  mounted() {
    bus.$on("headerCompanyChange", () => {
      let loading = this.$loading({
        lock: true,
        text: "切换中",
        spinner: "el-icon-loading",
        background: "hsla(0,0%,100%,.9)",
      });
      setTimeout(() => {
        loading.close();
      }, 1500);
      this.getSignData();
      this.getSignData2();
      this.getSignData3();
      // this.getSortedData()
      this.getCardData();
      this.getAnnounceList();
      // 文档列表
      this.getShowList();
      //我的待办列表
      this.runToBeList();
    });
  },
  filters: {},
  methods: {
    //  右侧卡片页面
    goview(index) {

      switch (index) {
        case 1:
          this.$router.push({ path: "/public-run-to-do" });
          break;
        case 2:
          this.$router.push("/public-run-notity");
          break;
        case 3:
          this.$router.push({
            name: "public-vun-hand-book",
            params: { publishSystem: "成员企业" },
          });
          break;
      }
    },
    /**
     * 获取公告列表
     */
    getAnnounceList() {
      // debugger;
      let _this = this;
      _this.loading = true;
      let param = {
        filterData: {
          publishLocation: ["跑马灯"],
        },
        pageData: {
          page: 0,
          pageSize: "3",
        },
      };
      getAnnounceList(param)
        .then((res) => {
          _this.loading = false;
          if (res.ret == "0") {
            let dataList = [...res.data.content];
            _this.marqueeList = dataList;
          } else {
            _this.$message.warning(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          _this.loading = false;
        });
      let param2 = {
        filterData: {
          publishLocation: ["公告栏"],
        },
        pageData: {
          page: 0,
          pageSize: "3",
        },
      };
      getAnnounceList(param2)
        .then((res) => {
          _this.loading = false;
          if (res.ret == "0") {
            // 公告栏,跑马灯
            let dataList = [...res.data.content];
            _this.AnnounceList = dataList;
          } else {
            _this.$message.warning(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          _this.loading = false;
        });
    },
    //跳转 公告详情
    goAnnounceDteail(item) {
      this.goAnnounceMsg = item || {};
      this.centerDialogVisibleMsg = true;
      // this.$alert(item.content, item.title, {
      //   confirmButtonText: "确定",
      // });
    },
    goallDL() {
      console.log("goallDL");
    },
    moreSign() {
      //待签发
      this.toQianfa();
    },
    skipToMyDiLink() {
      //我的迪链
      this.toMyDilian();
    },
    moreSort() {
      //我的清分
      this.toQingfen();
    },
    moreCash() {
      //现金折扣
      this.toDiscount();
    },
    alreadyCash() {
      //已放款
      this.toMyDilian();
    },
    getSignData2() {
      //查询已签发
      const parameters = {
        filterData: {
          bizScence: "00",
        },
        pageData: {
          page: 1,
          pageSize: 10,
        },
        sortDatas: [
          {
            direction: "DESC",
            sortParam: "issueDate",
          },
        ],
      };
      this.$POST(this.submember["006"], parameters).then((res) => {

        if (res.ret == "0" && res.data) {
          if (res.data.totalAmount) {
            this.hasSignedAmount = this.$utif.moneyFLoatFormat(
              res.data.totalAmount
            );
          } else {
            this.hasSignedAmount = "0.00";
          }
          this.loading = false;
        }
      });
    },
    getSignData3() {
      //查询当月已签发

      this.getFirstAndLastDay();
      const parameters = {
        filterData: {
          bizScence: "00",
          issueDateStart: this.firstDate,
          issueDateEnd: this.lastDate,
        },
        pageData: {
          page: 1,
          pageSize: 10,
        },
        sortDatas: [
          {
            direction: "DESC",
            sortParam: "issueDate",
          },
        ],
      };
      this.$POST(this.submember["006"], parameters).then((res) => {
        if (res.ret == "0" && res.data) {

          if (res.data.totalAmount) {
            this.hasSignedMonthAmount = this.$utif.moneyFLoatFormat(
              res.data.totalAmount
            );
          } else {
            this.hasSignedMonthAmount = "0.00";
          }
          this.loading = false;
        }
      });
    },
    getSignData() {
      //查询签发金额
      this.$POST("/ac/first/page/inf", { sence: "2" })
        .then((res) => {
          if (res && res.data) {
            this.pageData = JSON.parse(JSON.stringify(res.data));
            this.waitSignAmount = this.$utif.moneyFLoatFormat(
              res.data.issuableTotalAmt
            ); //待签发
            // this.pageData.hasSignedAmount = this.$utif.moneyFLoatFormat(
            //   res.data.issuedTotalAmt
            // );//已签发
            // this.pageData.hasSignedMonthAmount = this.$utif.moneyFLoatFormat(
            //   res.data.issuedCurrentMonthAmt
            // );
          }
        })
        .catch((err) => {
          console.log("submember-firstpage-err", err);
        });
    },
    getFirstAndLastDay() {
      let now = new Date();
      let strLink = "-";
      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      let lastDay = this.getLastDay(year, month);
      this.firstDate = year + strLink + month + strLink + "01";
      this.firstDate += " 00:00:00";
      this.lastDate = year + strLink + month + strLink + lastDay;
      this.lastDate += " 00:00:00";

      // let returnArr = [firstDate, lastDate];//以数组形式返回
      // return returnArr;
    },
    getLastDay(year, month) {
      let new_year = year;
      let new_month = month++; //取下一个月的第一天，方便计算（最后一天不固定）
      if (month > 12) {
        //如果当前大于12月，则年份转到下一年
        new_month -= 12; //月份减
        new_year++; //年份增
      }
      // 取当年当月对应的下个月的前一天，即当前月的最后一天
      let last_date = new Date(new_year, new_month, 0).getDate();
      return last_date;
    },
    getCardData() {
      //查询清分金额
      this.$GET(`/bs/voucher/inf/sumamount`)
        .then((res) => {
          if (res.ret == "0") {
            // this.pageData = JSON.parse(JSON.stringify(res.data));
            this.cardData = res.data;
          }
        })
        .catch((err) => {
          console.log("submember-firstpage-err", err);
        });
    },
    getSortedData() {
      //查询清分金额
      const enterpriseCode = "ccb";
      this.$GET(`/ac/voucher/inf/sumamount?enterpriseCode=${enterpriseCode}`)
        .then((res) => {
          // if (res && res.data) {
          //     this.pageData = JSON.parse(JSON.stringify(res.data))
          //     this.pageData.waitSignAmount = this.$utif.moneyFLoatFormat(res.data.issuableTotalAmt)
          //     this.pageData.hasSignedAmount = this.$utif.moneyFLoatFormat(res.data.issuedTotalAmt)
          //     this.pageData.hasSignedMonthAmount = this.$utif.moneyFLoatFormat(res.data.issuedCurrentMonthAmt)
          // }
        })
        .catch((err) => {
          console.log("submember-firstpage-err", err);
        });
    },
    // 获取文档中心列表
    getShowList() {
      let param = {
        filterData: {
          startTime: "",
          endTime: "",
          tagClassify: "",
          fileName: "",
          publishSystem: "成员企业",
        },
        pageData: {
          page: 0,
          pageSize: "3",
        },
        sortDatas: [],
      };
      this.$POST("/bds/publicrs/guideline/showList", param).then((res) => {
        if (res.ret == "0") {
          this.documentCenterList = res.data.content; //res.data.content;
        }
      });
    },
    // 文档下载
    upDocumentCenter(val) {
      let param = {
        id: val.id,
      };
      window.open(
        this.$BASEURL + "/bds/publicrs/image/" + val.fileId + "?download=true"
      );
      // this.$exportFileFunc("", "", '/bds/publicrs/image/'+ val.fileId , "get", {download: true});
      this.$GET(
        "/bds/publicrs/guideline/downloaddegree",
        param
      ).then((res) => {});
    },
    toMyDilian() {
      this.$router.push("/subMember/diLink-mangement");
    },
    toQianfa() {
      this.$router.push("/subMember/my-issue");
    },
    toZiyuan() {
      this.$router.push("/subMember/my-resources");
    },
    toQingfen() {
      this.$router.push("/subMember/my-settle");
    },
    toDiscount() {
      this.$router.push("/subMember/cash-discount");
    },

    runToBeList() {
      let params = {
        filterData: {},
        pageData: { page: 1, pageSize: 3 },
      };
      this.$POST("op/workbench/tobetask/list", params).then((res) => {
        if (res.ret == "0" && res.data.content) {
          this.runTodoList = res.data.content;
        }
      });
    },
    tobeListDetail(item) {
      let params = {
        taskInstId: item.task_inst_id,
      };
      this.$POST("/op/workbench/task/take", params).then((res) => {
        if (res.ret == "0") {
          this.$message.success('任务认领成功！')
          this.$router.push({
            path: item.task_url,
            query: {
              business_id: item.business_id,
              task_inst_id: item.task_inst_id,
              task_node: item.task_node,
              state: "runToDo", // 待办事项跳转 标示
            },
          });
        } else {
          // this.$message({ type: "warning", message: "此任务已被认领" });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  width: 100%;
  // height: 100%;
  background: #f8f8f8;

  .sm-content {
    min-height: calc(100% - 80px - 30px);
  }
}
.laba {
  margin-right: 4px;
  margin-left: 14px;
}
.more {
  margin-left: 4px;
  margin-right: 8px;
}

// .wrapConter {
//   width: 100%;
//   height: 130px;
//   position: relative;
// }
// .wrapConter img {
//   height: 130px;
//   width: 100%;
// }
// .top {
//   min-width: 1200px;
//   max-width: 1754px;
//   margin: 0 83px;
//   height: 56px;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   background: #ffffff;
//   box-shadow: 0px 4px 10px #e5e8f2;
//   opacity: 1;
//   border-radius: 2px;
//   position: relative;
//   left: 0;
//   bottom: 28px;
//   z-index: 1;
// }
// .top .topLeft {
//   font-size: 14px;
//   font-family: MicrosoftYaHei;
//   line-height: 14px;
//   color: #858692;
//   opacity: 1;
// }
// .top .topRight {
//   margin-right: 20px;
//   color: #b7bcc6;
//   font-size: 14px;
//   font-family: MicrosoftYaHei;
//   line-height: 14px;
//   color: #b7bcc6;
//   opacity: 1;
//   cursor: pointer;
// }
// .topLeft img {
//   width: 16px;
//   height: 15px;
// }
// .wrapBottom {
//   .topRight {
//     color: #b7bcc6;
//   }
//   .topRight img {
//     width: 20px;
//     height: 10px;
//   }
// }
// .topLeft,
// .topRight {
//   display: flex;
//   align-items: center;
// }
// .name {
//   display: none;
// }
.left {
  padding-right: 30px;
  margin-bottom: 30px;
  width: 75%;
}
.leftTop,
.leftBottom {
  // margin-top: 15px;
  background: #f8f8f8;
  display: flex;
  justify-content: space-between;
}
.leftTop {
  margin-top: 0;
  // margin-bottom: 15px !important;
}
.leftTop .item {
  width: 20%;
  // height: 0;
  // padding-bottom: 10%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 15px;
}
.leftTop .item img {
  width: 100%;
  // height: 100%;
}
.leftTop .item p {
  position: relative;
  bottom: 26px;
  width: 66px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium;
  line-height: 0px;
  color: #ffffff;
  opacity: 1;
}
.right {
  width: 25%;
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
}
.right .boxCard {
  margin-bottom: 16px;
  min-height: 155px;
  flex: 1;
}
.infoBox {
  position: relative;
  margin-bottom: 14px;
  display: flex;
  justify-content: flex-start;
}
.dotBox {
  height: 100%;
  width: 27px;
  float: left;
}
.dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: rgb(244, 91, 74);
  margin-top: 6px;
  margin-left: 11px;
  float: left;
}
.moreBox {
  width: 8px;
  float: left;
  position: absolute;
  right: 18px;
  bottom: 0;
  cursor: pointer;
}
.moreBox img {
  width: 8px;
  height: 8px;
}
.left .boxCard /deep/ .el-card__body{
  height: 350px;
}
.littleTitle {
  font-size: 17px;
  float: left;
  margin-left: 14px;
}
.info {
  font-size: 14px;
  line-height: 22px;
  float: left;
  width: calc(100% - 50px);
  text-overflow: ellipsis;
}
.amount {
  font-size: 24px;
  margin-left: 60px;
  margin-top: 10px;
  margin-bottom: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    width: 20px;
    height: 10px;
    margin-right: 35px;
  }
}
.cardHeader {
  height: 22px;
  margin-bottom: 14px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .topRight {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    line-height: 19px;
    color: #b7bcc6;
    opacity: 1;
    img {
      width: 20px;
      height: 10px;
    }
  }
}
.cardHeader img {
  height: 22px;
  width: 20px;
  float: left;
}
.add-arrow {
  position: relative;
  img {
    position: absolute;
    top: 50%;
    margin-top: -5px;
    right: 0;
  }
}
.titleStyle {
  font-size: 16px;
  float: left;
  color: #1b5bbf;
  line-height: 22px;
  margin-left: 6px;
  cursor:pointer;
}
.right /deep/ .el-card__body {
  padding-bottom: 0px;
  padding-left: 16px;
  padding-top: 10px;
}
// .dbcard {
//   height: 170px;
// }
// .ggcard {
//   height: 173px;
// }
// .wdcard {
//   height: 175px;
// }
.printer {
  cursor: pointer;
}
// 公告弹窗 ui样式
/deep/.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    padding: 20px 20px 1px;
  }
  .el-dialog__body {
    padding: 0px 25px 30px;
  }
}
</style>